import React from 'react'
import SubsDetails from '../../components/Subscription/SubsDetails'
import SubsLayout from '../../layout/SubsLayout'

const SubsDetailsPage = () => {
  return (
    <SubsLayout>
        <SubsDetails />
    </SubsLayout>
  )
}

export default SubsDetailsPage